import { useQuery } from "@tanstack/react-query"

import fetchObjectListData from "@utils/fetchObjectListData"

import { UseUnfilteredTabCountProps } from "@organisms/ObjectsView/ObjectsView.types"

/**
 * Count the active tab's rows on its base filters alone, with every view setting stripped.
 *
 * Tells "nothing matches" apart from "a view setting hid everything". Fires only while enabled,
 * which is the one moment the number is shown.
 */
export default function useUnfilteredTabCount(props: UseUnfilteredTabCountProps) {
    const { activeTab, tabContentName, searchKeywords, filters, isEnabled } = props

    const { data, isLoading } = useQuery({
        queryKey: [
            "unfilteredTabCount",
            activeTab?.countEndpoint,
            activeTab?.endpointKwargs,
            searchKeywords,
            filters,
            filters?.toString(),
            tabContentName,
        ],
        queryFn: () =>
            fetchObjectListData({
                objectName: `Unfiltered ${tabContentName} Count`,
                endpoint: activeTab?.countEndpoint ?? null,
                endpointKwargs: activeTab?.endpointKwargs || [],
                searchKeywords,
                filters,
            }),
        staleTime: 60000,
        enabled: isEnabled && !!activeTab?.countEndpoint,
    })

    return { unfilteredTabCount: data?.count, isUnfilteredTabCountLoading: isLoading }
}
